import React, {Component} from "react";
import {Icon, Select} from "antd";
import {uuid} from "../../../../../utils";
import BaseComponent from "../../../../../base/BaseComponent";

const Option = Select.Option;
let windowKeyup;
export default class RoleSelect extends BaseComponent {
    static defaultProps = {
        isEnable:true
    };
    static propTypes = {};
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            key:"",
        };
    }

    componentDidMount() {
        this.roleList();
    }

    render() {
        const {dataSource} = this.state;
        let {value, onChange, mode, placeholder} = this.props;
        value = value.filter(code => {
            return dataSource.some(item => item.roleCode === code);
        });
        return (
                <Select
                    placeholder={placeholder}
                    suffixIcon={[<Icon key={uuid()} type="right"/>]}
                    showArrow={true}
                    onDropdownVisibleChange={e => {
                        console.log(e);
                        if (e) {
                            windowKeyup = window.onkeyup;
                            window.onkeyup = null;
                        } else {
                            window.onkeyup = windowKeyup;
                            window.onkeyup = null;
                        }
                    }}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    onBlur={()=>{
                        this.inputOnBlur();
                        window.onkeyup= windowKeyup
                    }}
                    mode={mode}
                    filterOption={(inputValue, option)=>option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
                    value={value}
                    onChange={onChange}
                    disabled={this.props.isEnable?false:true}
                >
                    {
                        dataSource.map(item => {
                            return <Option key={item.id} value={item.roleCode}>{item.roleName}</Option>;
                        })
                    }
                </Select>
        );
    }
    inputOnBlur=()=>{
        this.setState({
            onBlur:false
        })
    }

    roleList = () => {
        this.roleConditionQueryRequest(res => {
            this.setState({
                dataSource: res.data
            });

        });
    };
    roleConditionQueryRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/role/conditionQuery",
            contentType: "json",
            method: "post",
            body: {size: 99999},
            callBack
        });
    };
}

